var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 6.66665H17.6667V5.66665H16.6667V6.66665ZM16.6667 16.6666V17.6666H17.6667V16.6666H16.6667ZM3.33333 16.6666H2.33333V17.6666H3.33333V16.6666ZM3.33333 6.66665V5.66665H2.33333V6.66665H3.33333ZM2.5 3.33331V2.33331H1.5V3.33331H2.5ZM17.5 3.33331H18.5V2.33331H17.5V3.33331ZM17.5 6.66665V7.66665H18.5V6.66665H17.5ZM2.5 6.66665H1.5V7.66665H2.5V6.66665ZM8.33333 8.99998H7.33333V11H8.33333V9.99998V8.99998ZM11.6667 11H12.6667V8.99998H11.6667V9.99998V11ZM16.6667 6.66665H15.6667V16.6666H16.6667H17.6667V6.66665H16.6667ZM16.6667 16.6666V15.6666H3.33333V16.6666V17.6666H16.6667V16.6666ZM3.33333 16.6666H4.33333V6.66665H3.33333H2.33333V16.6666H3.33333ZM3.33333 6.66665V7.66665H16.6667V6.66665V5.66665H3.33333V6.66665ZM2.5 3.33331V4.33331H17.5V3.33331V2.33331H2.5V3.33331ZM17.5 3.33331H16.5V6.66665H17.5H18.5V3.33331H17.5ZM17.5 6.66665V5.66665H2.5V6.66665V7.66665H17.5V6.66665ZM2.5 6.66665H3.5V3.33331H2.5H1.5V6.66665H2.5ZM8.33333 9.99998V11H11.6667V9.99998V8.99998H8.33333V9.99998Z",
    fill: "#8F97A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive-icon.65c8043c.svg";
export { ForwardRef as ReactComponent };